import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column kn-flex kn-overflow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_TimespanForm = _resolveComponent("TimespanForm")
  const _component_TimespanIntervalTable = _resolveComponent("TimespanIntervalTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.timespan?.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.saveDisabled,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveTimespan(null))),
          "data-test": "save-button"
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTimespanDetailsConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          class: "kn-progress-bar",
          mode: "indeterminate",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_TimespanForm, {
        propTimespan: _ctx.timespan,
        categories: _ctx.categories,
        onTouched: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touched = true))
      }, null, 8, ["propTimespan", "categories"]),
      _createVNode(_component_TimespanIntervalTable, {
        propTimespan: _ctx.timespan,
        onTouched: _cache[3] || (_cache[3] = ($event: any) => (_ctx.touched = true))
      }, null, 8, ["propTimespan"])
    ])
  ], 64))
}